module.exports = __webpack_public_path__ + "img/image_offline04@2x.3562338a.png";